export const DEBUG_ELEMENT_PLACEHOLDER_NAME = 'elementPlaceholderDebugTool';
export const DEBUG_ELEMENT_PLACEHOLDER_STATE_UPDATE = 'DEBUG_ELEMENT_PLACEHOLDER_STATE_UPDATE';
